/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: config.js
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  26.09.22 3:29 pm.
 * Last modified: 26.09.22 3:29 pm.
 *
 * More information at: https://egt-digital.com/
 */
export const getDynamicMostPlayedGamesUrl = (host: string): string => `${host}/api/history/statistics/top-games`;
export const getGamesCurrentPlayersUrl = (host: string): string =>
    `${host}/api/history/statistics/current-players-count`;
export const getSettingsUrl = (host: string, demo: boolean = false): string =>
    `${host}/api/portal/settings${demo ? '?isDemo=true' : ''}`;
export const getJackpotStatsUrl = (host: string): string => `${host}/api/jackpot/stats`;
export const getTranslationsUrl = (host: string, languageCode: string): string =>
    `${host}/assets/portal/translations/${languageCode.toLowerCase()}.json`;
